// Google Calendar: las entregas, devoluciones y rentas en el calendario de la
// empresa. Conexión directa (al instante) o enlace de suscripción.
import { el, clear } from '../../utils/dom.js';
import { Rentals } from '../../api/resources.js';
import { ok, err, info } from '../../components/toast.js';
import { confirm } from '../../components/modal.js';
import { fmtDateTime } from '../../utils/format.js';

const OPCIONES = [
  ['entrega', 'Entregas', 'Cuando sale el equipo (1 hora)'],
  ['devolucion', 'Devoluciones', 'Cuando vuelve el equipo (1 hora)'],
  ['renta', 'Renta completa', 'Un bloque de la entrega a la devolución'],
  ['cotizaciones', 'Cotizaciones', 'También las que todavía no son renta'],
];

export default async function GooglePage(outlet, ctx) {
  clear(outlet);
  if (ctx?.query?.ok) ok('Google Calendar conectado. Ya se están agendando tus rentas.');
  if (ctx?.query?.error) err(ctx.query.error === 'cancelado' ? 'No se terminó la conexión con Google.' : decodeURIComponent(ctx.query.error));
  if (ctx?.query?.ok || ctx?.query?.error) history.replaceState(null, '', '#/calendario/google');

  let e;
  try { e = await Rentals.googleEstado(); }
  catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }
  const recargar = () => GooglePage(outlet, {});

  outlet.appendChild(el('div', { class: 'page-head' },
    el('div', {}, el('h1', {}, 'Google Calendar'), el('div', { class: 'muted' }, 'Tus entregas, devoluciones y rentas, agendadas solas en tu calendario')),
    el('a', { href: '#/calendario', class: 'btn ghost' }, '← Calendario')));

  // ------------------------------------------------ conexión directa
  const directa = el('section', { class: 'card mb-4' }, el('h3', { class: 'rp-h' }, 'Conexión directa (al instante)'));
  if (!e.configurado) {
    directa.appendChild(el('p', { class: 'msg-aviso text-sm' }, 'La conexión con Google no está lista en el servidor. Mientras tanto usa el enlace de abajo.'));
  } else if (!e.conectado) {
    directa.append(...[
      el('p', { class: 'muted text-sm' }, 'Entras con tu cuenta de Google y desde ese momento cada renta nueva, cada cambio de fecha, cada pago y cada cancelación se ven en tu Google Calendar en menos de un minuto. Tu cliente no recibe nada: es solo para ti y tu equipo.'),
      e.error ? el('p', { class: 'msg-aviso text-sm' }, e.error) : null,
      el('ol', { class: 'text-sm msg-pasos' },
        el('li', {}, 'Toca "Conectar con Google" y elige la cuenta de Google de tu empresa.'),
        el('li', {}, 'Si Google dice "Google no ha verificado esta app", toca "Configuración avanzada" y luego "Ir a…". Es la app de la plataforma.'),
        el('li', {}, 'Toca "Permitir". Vuelves aquí y tus rentas empiezan a aparecer en tu calendario.')),
      el('button', { class: 'btn primary', onclick: async (ev) => {
        ev.target.disabled = true;
        try { const r = await Rentals.googleConectar(); location.href = r.url; }
        catch (ex) { err(ex.message); ev.target.disabled = false; }
      } }, 'Conectar con Google')].filter(Boolean));
  } else {
    const sel = el('select', { class: 'select', 'aria-label': 'Calendario' }, el('option', { value: e.calendario_id }, e.calendario_nombre || (e.calendario_id === 'primary' ? 'Calendario principal' : e.calendario_id)));
    Rentals.googleCalendarios().then((lista) => {
      sel.replaceChildren(...lista.map((c) => { const o = el('option', { value: c.id }, `${c.nombre}${c.principal ? ' (principal)' : ''}`); if (c.id === e.calendario_id) o.selected = true; return o; }));
    }).catch(() => {});
    const checks = OPCIONES.map(([k, t, d]) => {
      const inp = el('input', { type: 'checkbox', checked: !!e.opciones[k] });
      return { k, inp, nodo: el('label', { class: 'checkbox' }, inp, el('span', {}, el('strong', {}, t), el('span', { class: 'muted text-sm' }, ` — ${d}`))) };
    });
    directa.append(...[
      el('p', {}, '✅ Conectado con ', el('strong', {}, e.email || 'tu cuenta de Google')),
      e.error ? el('p', { class: 'msg-aviso text-sm' }, e.error) : null,
      el('p', { class: 'muted text-sm' }, `${e.eventos} evento${e.eventos === 1 ? '' : 's'} en tu calendario${e.con_error ? ` · ${e.con_error} con error (se reintenta solo)` : ''}${e.ultimo ? ` · último cambio ${fmtDateTime(e.ultimo)}` : ''}`),
      el('div', { class: 'field mt-2' }, el('label', {}, 'Agendar en'), sel),
      el('p', { class: 'rp-sub mt-3' }, 'Qué se agenda'),
      el('div', { class: 'msg-eventos' }, ...checks.map((c) => c.nodo)),
      el('p', { class: 'muted text-sm mt-2' }, 'En el título: ⏳ por confirmar · ✅ confirmada · 📦 afuera · ⚠️ atrasada · ✔︎ terminada. Las canceladas se borran solas.'),
      el('div', { class: 'flex gap-2 wrap mt-3' },
        el('button', { class: 'btn primary', onclick: async () => {
          try {
            await Rentals.googleAjustar({ calendario_id: sel.value, calendario_nombre: sel.selectedOptions[0]?.textContent || null,
              opciones: Object.fromEntries(checks.map((c) => [c.k, c.inp.checked])) });
            ok('Guardado. Tu calendario se actualiza en un momento.'); recargar();
          } catch (ex) { err(ex.message); }
        } }, 'Guardar'),
        el('button', { class: 'btn', onclick: async (ev) => {
          ev.target.disabled = true;
          try { const r = await Rentals.googleSincronizar(); ok(`Listo: ${r.hechos} cambio${r.hechos === 1 ? '' : 's'} en Google`); recargar(); }
          catch (ex) { err(ex.message); ev.target.disabled = false; }
        } }, 'Sincronizar ahora'),
        el('button', { class: 'btn ghost', onclick: async () => {
          if (!(await confirm({ title: 'Desconectar Google Calendar', message: 'Las rentas dejan de agendarse en tu Google. Lo que ya está en tu calendario se queda ahí.', confirmText: 'Desconectar', danger: true }))) return;
          const borrar = await confirm({ title: '¿Borrar también los eventos?', message: '¿Quitamos de tu Google Calendar los eventos que puso el Inventario?', confirmText: 'Sí, borrarlos', cancelText: 'No, dejarlos' });
          try { await Rentals.googleDesconectar(!!borrar); ok('Desconectado'); recargar(); } catch (ex) { err(ex.message); }
        } }, 'Desconectar'))].filter(Boolean));
  }
  outlet.appendChild(directa);

  // ------------------------------------------------ enlace de suscripción
  const enlace = el('input', { class: 'input grow', value: e.enlace_ics, readonly: true, 'aria-label': 'Enlace del calendario', onclick: (ev) => ev.target.select() });
  outlet.appendChild(el('section', { class: 'card mb-4' },
    el('h3', { class: 'rp-h' }, 'Enlace de suscripción (sin conectar cuenta)'),
    el('p', { class: 'muted text-sm' }, 'Para el calendario de alguien del equipo, o si no quieres conectar tu cuenta. Google lo actualiza solo cada pocas horas (no al instante). Quien tenga este enlace ve tus rentas: compártelo solo con tu equipo.'),
    el('div', { class: 'flex gap-2 wrap mt-2' }, enlace,
      el('button', { class: 'btn', onclick: async () => {
        try { await navigator.clipboard.writeText(enlace.value); ok('Enlace copiado'); } catch { enlace.select(); info('Cópialo con Ctrl + C'); }
      } }, 'Copiar')),
    el('ol', { class: 'text-sm msg-pasos mt-2' },
      el('li', {}, 'Google Calendar en la computadora: a la izquierda, "Otros calendarios" → "+" → "Desde URL" → pega el enlace → "Añadir calendario".'),
      el('li', {}, 'iPhone: Ajustes → Calendario → Cuentas → Añadir cuenta → Otra → "Añadir calendario suscrito" → pega el enlace.')),
    el('button', { class: 'btn ghost text-sm', onclick: async () => {
      if (!(await confirm({ title: 'Cambiar el enlace', message: 'El enlace viejo deja de funcionar. Quien lo tenga tendrá que agregar el nuevo.', confirmText: 'Cambiar', danger: true }))) return;
      try { await Rentals.googleEnlaceNuevo(); ok('Enlace nuevo listo'); recargar(); } catch (ex) { err(ex.message); }
    } }, 'Cambiar el enlace')));
}
